import state from './state'
import mutations from './mutations'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    hide:false,
	openAnnounce:true
  },
  mutations,
  actions: {},
  modules: {}
})